module.exports = __webpack_public_path__ + "img/iatan.876fed51.jpg";